<nz-breadcrumb (window:resize)="onWindowResize()">
  <ng-container *ngFor="let breadcrumb of breadcrumbs; let idx=index">
    <nz-breadcrumb-item *ngIf="!breadcrumb.hide">
      <a
        *ngIf="breadcrumb.link else breadcrumbText"
        [class.no-events]="breadcrumb.disabled"
        [routerLink]="breadcrumb.link">
        <ng-container *ngTemplateOutlet="breadcrumbText"></ng-container>
      </a>
      <ng-template #breadcrumbText>
        <ng-container *ngIf="!breadcrumb.collapsedText else breadcrumbCollpased">
          <span [attr.data-e2e]="breadcrumb.text">{{breadcrumb.text}}</span></ng-container>
        <ng-template #breadcrumbCollpased>
          <span phx-tooltip [phxContent]="breadcrumb.text">{{breadcrumb.collapsedText}}</span>
        </ng-template>
      </ng-template>
    </nz-breadcrumb-item>
  </ng-container>
</nz-breadcrumb>
